import { render, staticRenderFns } from "./listInfo.vue?vue&type=template&id=03a45f88&scoped=true&"
import script from "./listInfo.vue?vue&type=script&lang=js&"
export * from "./listInfo.vue?vue&type=script&lang=js&"
import style0 from "./listInfo.vue?vue&type=style&index=0&id=03a45f88&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a45f88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VChip,VSelect,VToolbar})
